var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "group-item-header" }, [_c('strong', { attrs: { "id": _vm.name.replace(/\s/, '') } }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _vm._t("header-tail")], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };